module.exports = __webpack_public_path__ + "img/customer_01.5299b1d2.jpg";